module.exports = __webpack_public_path__ + "static/media/iso31000.3cd40e32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/iso31000.png
// module id = 1579
// module chunks = 0